<template>  <div v-if="page.home" class="page hello">
    <div class="hello--logo">
      <div class="hello--logo-pic hello--logo-animated">
        <svg v-if="!isIE11" viewBox="0 0 669 482">
          <g id="Canvas" transform="translate(-3742 2351)">
          <g id="logo">
          <use xlink:href="#path0_fill" transform="translate(3742 -2351)" fill="#FFFFFF"/>
          </g>
          </g>
          <defs>
          <path id="path0_fill" fill-rule="evenodd" d="M 669 0L 0 0L 0 482L 669 482L 669 0ZM 481.799 6L 604.049 127.918L 658.318 182.042L 549.752 182.042L 422.625 182.042L 246.159 6L 481.799 6ZM 264.881 78.9241L 124.428 240.646L 263.959 401.195L 272.302 410.822L 227.697 455.319L 208.324 474.661L 144.488 401.195L 5 240.646L 145.516 78.9241L 208.851 6L 227.698 24.8091L 271.848 68.8269L 272.777 69.8931L 264.881 78.9241ZM 422.599 299.33L 549.779 299.33L 658.283 299.33L 604.021 353.454L 481.771 475.373L 246.159 475.373L 422.599 299.33Z"/>
          </defs>
        </svg>
        <img v-else src="/static/masks/logo.png"/>
      </div>
    </div>
    <div class="hello--name">
      <h1><TextAnimation :word="page.home.title" :delay="600" :speed="80"/></h1>
      <div :class="`lead lead-${animation ? 'animated' : ''}`">
        <p v-html="page.home.text_lead"/>
        <p class="sotbi-animation" v-html="page.home.text_lead_modern"/>
      </div>
    </div>

    <div :class="`hello--stat hello--stat-${theme === 'white' ? 'visible' : ''} hello--stat-${animation ? 'animated' : ''} font-grotesque`">
      <div class="container hello--stat-wrap">
        <div v-for="num, key in statistic()" :class="`col-md-3 col-xs-6 hello--stat-col hello--stat-col-${animation ? 'animated' : ''}`" :style="`transition-delay: ${(key / 5)}s`">
          <h3 :ref="`desc_${key}`" >
            <TextOdometer v-if="key === 3"  :delay="4000" :speed="1200" :word="page.home[num]" :year_total="page.home.text_number_last"/>
            <TextPercentAnimation v-else :counter="false" :delay="4000" :speed="1200" :word="page.home[num]"/>
          </h3>
          <div v-html="page.home[`text_numbers_desc_0${key+1}`]"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import TextPercentAnimation from '@/components/TextPercentAnimation';
import TextAnimation from '@/components/TextAnimation';
import TextOdometer from '@/components/TextOdometer';

import IEDetector from '@/mixins/IEDetector';

export default {
  mixins: [IEDetector],

  components: {
    TextPercentAnimation,
    TextAnimation,
    TextOdometer,
  },

  computed: mapGetters({
    firstVisitAnimation: 'firstVisitAnimation',
    animation: 'animation',
    loaded: 'loaded',
    theme: 'theme',
    page: 'page',
  }),

  methods: {
    statistic() {
      // const stat = myKeys.filter(function(key){ return key.indexOf(myString) !== -1 });
      const stat = Object.keys(this.page.home).filter(key => key.indexOf('text_numbers_0') > -1);
      return stat;
    },
  },
};
</script>

<style>
.hello{
  position: relative;
  padding-top: 40px;
  padding-left: 0;


  width: $whitePageWide;
  max-width: $whitePageMaxWide;

  @media (max-width: $mediaMob) {
    padding-top: 90px;
  }

  &:after{
    background: white;
    position: absolute;
    z-index: -1;
    content: '';
    height: 100%;
    width: 50%;
    right:  0%;
    top: 0;
    
  }

  &--logo:before{
    max-width: $whitePageMaxWide;
    width: $whitePageWide;
    position: absolute;
    background: white;
    height: 100px;
    content: '';
    z-index: 1;
    left: 0;
    top: 0;
  }

  &--logo,
  &--name{
    display: inline-block;
    vertical-align: top;
    padding: 0;
    margin: 0;
    border: 0;
    @media (max-width: $mediaMini) {
      display: block;
    }
  }

  /*&--name,*/
  &--logo{
    &:after{
      position: absolute;
      background: white;
      content: '';
      z-index: -1;
      height: 100%;
      width: 100%;
      min-width: 155px;
      right: -255px;
      top: 0;
      
    }
  }

  &--logo{
    @media (max-width: $mediaMini) {
      width: 55%;
    }
    @media (max-width: $mediaTiny) {
      width: 200px;
    }

    &-pic{
      transform: translate3d(-550px,0,0);
      transition: all .8s $mainAnimationTransition;
      display: inline-block;
      position: relative;
      max-width: 680px;
      min-width: 150px;
      width: 50vw;
      height: auto;
      left: -25%;

      @media (max-width: $mediaMini) {
        width: 100%;
      }

      img,
      svg{
        position: relative;
        height: 100%;
        width: 100%;
      }
      
      &:after{
        position: absolute;
        background: white;
        max-width: 760px;
        height: 100%;
        content: '';
        z-index: -1;
        width: 45vw;
        left: 99%;
        top: 0;

        @media (max-width: $mediaMini) {
          width: 40vw;
        }
      }
    }

    &-animated{
       transform: translate3d(0,0,0);
       img,
       svg{
        opacity: 1;
      }
    }

    &:before{
      max-width: $whitePageWide;
      height: 100%;
      width: 500%;
      z-index: -1;
      top: -99%;
    }

    &:after{
      right: initial;
      top: initial;
      bottom: -210px;
      height: 220px;
      left: 0;
      @media (max-width: $mediaIpad) {
        height: 228px;
        bottom: -220px;
      }
    }
  }

  &--name{
    padding: 12vw 40px 10px;
    position: relative;
    background: white;
    color: $brandDark;
    margin: 0 -5px;
    width: 45%;
    top: -5px;

    @media (min-width: $mediaLaptop) {
      padding-top: 150px;
    }


    .lead{
      margin-top: -20px;

      .sotbi-animation,
      p{
        transition: opacity .3s ease-in-out;
      }

      .sotbi-animation{
        position: absolute;
        margin-top: 0;
        opacity: 0;
        top: 35px;
        left: 0;
      }
    }

    h1:hover{
      & + .lead{
        p{
          opacity: 0;
        }
        .sotbi-animation{
          opacity: 1;
        }
      }
    }

    @media ( width: 1300px) {
      padding-top: 150px;
    }

    @media (max-width: $mediaMini) {
      padding: 10px 5%;
      margin-left: 5%;
      width: 90%;
    }

    h1{
      font-size: 1280%;

      .app-en & {
        line-height: 1.2;
      }

      @media (max-width: 1380px) {
        font-size: 1000%;
      }
      @media (max-width: $mediaLaptop) {
        .app-en & {
          line-height: 1.5;
        }
        font-size: 900%;
      }
      @media (max-width: $mediaIpad) {
        font-size: 800%;
      }

      @media (max-width: $mediaMob) {
        font-size: 500%;
      }

      @media (max-width: $mediaTiny) {
        font-size: 350%;
      }
    }
    .lead{
      @media (max-width: $mediaTiny) {
        font-size: 100%;
        margin-top: -5px;
      }
    }
  }

  &--stat{
    letter-spacing: 1px;
    padding: 50px 0 20px;
    margin-top: -8px;
    background: white;
    color: $brandDark;

    @media (max-width: $mediaSmallScreen) and (min-width: $mediaIpad) {
      padding-top: 20px;
    }

    @media (max-width: $mediaMini) {
      padding-right: 5%;
      padding-left: 5%;
      font-size: 90%;
    }

    h3{
      height: 50px;
      .page-back &{
        overflow: hidden;
      }

      @media (max-width: $mediaIpad) {
        margin-top: 0;
      }
    }

    &-col{
      transition: all .3s ease-in-out;
      opacity: 0;

      @media (max-width: $mediaSmallScreen) {
        position: relative;
        max-width: 260px;
        left: -250px;
        width: 50%;
      }

      @media (max-width: 1080px) {
        max-width: 245px;
        left: -140px;
      }

      @media (max-width: 880px) {  
        max-width: 200px;
      }

      @media (max-width: $mediaMini) {
        padding-left: 0;
        left: 0;
      }

      @media (max-width: $mediaTiny) {
        max-width: 100%;
        width: 100%;
      }
    

      &-animated{
        opacity: 1;
      }
    }

    &-wrap.container{
      max-width: 800px;

      @media (max-width: $mediaSmallScreen) {
        margin-left: 560px;
      }
      @media (max-width: $mediaIpad) {
        margin-left: 40vw;
      }
      @media (max-width: 1100px) {
        max-width: 80%;
      }
      @media (max-width: $mediaMini) {
        margin-left: 5%;
        padding: 0;
      }
    }
  }

  .lead{
    transition: all .4s ease-in-out;
    transform: translate3d(0, 20px, 0);
    opacity: 0;

    &-animated{
      transform: translate3d(0,0,0);
      white-space: nowrap;
      opacity: 1;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue